import React from 'react'
import { FormWizardContext } from './context'
import { FormPreview } from './FormPreview'
import { useFormWizardData } from './hooks'
import { StageModal } from './StageModal'
import { FormWizardProps } from './types'

export const FormWizard = ({
  form,
  data,
  corrections,
  onSubmit,
  stageId,
  selectStage,
  adminView,
  getStoragePath,
  renderStage,
  withPreview,
  readOnly,
  ReadOnlyFooter,
}: FormWizardProps) => {
  const formWizardData = useFormWizardData(
    form,
    data,
    corrections,
    onSubmit,
    stageId,
    selectStage,
    renderStage,
    readOnly,
    ReadOnlyFooter,
    getStoragePath,
    adminView,
  )
  const { stage } = formWizardData
  return (
    <FormWizardContext.Provider value={formWizardData}>
      {stage ? <StageModal /> : null}
      {withPreview ? (
        <FormPreview
          corrections={corrections ?? {}}
          onStageEdit={formWizardData.open}
          form={form}
          data={data}
        />
      ) : null}
    </FormWizardContext.Provider>
  )
}
